
import { Component, Vue, Watch } from 'vue-property-decorator'
import { download } from '@/api/download'
import { AppModule } from '@/store/modules/app'
import axios from 'axios'
import version from './components/detail.vue'
import { mixins } from 'vue-class-component'
import currencyOptionMixin from '@/mixin/currencyOption'

@Component({
  name: 'download',
  components: {
    version
  }
})
export default class extends mixins(currencyOptionMixin) {
  // private currencyTypes: any[] = this.$store.state.app.enterprise
  //   .available_currency
  // private currency: string = AppModule.currentCurrencyType
  // private loading: boolean = false
  // private files: any[] = []
  // private async getList () {
  //   try {
  //     this.loading = true
  //     await download({ currency: this.currency }).then((res: any) => {
  //       this.files = res.files
  //       this.loading = false
  //     })
  //   } catch (e) {
  //     this.loading = false
  //   }
  // }

  private smsLink: any = this.$store.state.app.enterprise.sms_apk
  private smsApkLink() {
    window.open(this.smsLink)
  }

  private jump(row: any) {
    window.open(row)
  }

  queryForm: any = { name: '' }

  private select() {
    this.hadleGetFilesListApi()
  }

  private reset() {
    this.queryForm.name = ''
    this.hadleGetFilesListApi()
  }

  private versionDrawer: boolean = false
  private versionID: any = null
  private openVersion(row: any) {
    this.versionID = row.id
    this.versionDrawer = true
  }

  @Watch('currencyTypes')
  private watchCurrency() {
    this.queryForm.currency = this.currencyTypes[0]
    this.hadleGetFilesListApi()
  }
  private listLoading = false
  private total = 0
  private list: any[] = []

  private currencyChange(e: any) {
    AppModule.SetCurrentCurrencyType(this.queryForm.currency)
    this.queryForm.currency = e
    this.hadleGetFilesListApi()
  }

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange(size) {
    this.pagesize = size
    this.hadleGetFilesListApi()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange(currentPage) {
    this.currentPage = currentPage
    this.hadleGetFilesListApi()
  }

  // 对所有数据进行分页处理 发送请求
  private async hadleGetFilesListApi() {
    try {
      this.listLoading = true
      axios
        .get('https://dapi.paypptp.com/api/manage/open-plugin', {
          params: {
            ...this.queryForm,
            page_size: this.pagesize,
            page: this.currentPage
          }
        })
        .then((res: any) => {
          this.total = res.data.count
          this.list = res.data.results
          this.listLoading = false
        })
        .catch(() => {
          this.list = []
          this.listLoading = false
        })
    } catch (e) {
      this.listLoading = false
    }
  }

  private siteName = this.$store.state.app.enterprise.ssl_switch.site_name
  private systemName: any = 'Admin System'
  private sitelogo: any = this.$store.state.app.enterprise.ssl_switch.site_logo
  private systemLogo: any = ''

  mounted() {
    this.hadleGetFilesListApi()
    if (this.siteName && this.siteName !== '') {
      AppModule.SetSiteName(this.siteName)
      document.title = this.siteName + ' ' + this.$t(`route.operation`)
    } else {
      AppModule.SetSiteName(this.systemName)
      document.title = this.$t(`route.download`) + '- Admin System'
    }
    if (this.sitelogo && this.sitelogo !== '') {
      AppModule.SetSiteLogo(this.sitelogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.sitelogo
      document.getElementsByTagName('head')[0].appendChild(link)
    } else {
      AppModule.SetSiteLogo(this.systemLogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.systemLogo
      document.getElementsByTagName('head')[0].appendChild(link)
    }
  }
}
